
















































import {Component, Prop, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import TextField from "@/components/inputs/TextField.vue";
import Number from "@/components/inputs/Number.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
interface BannerEntity{
    "banner_id": 6,
    "image_url": "slider/5eb031682b807.jpg",
    "thumb_url": "slider/thumb/5eb031682b807.jpg",
    "title": "asd",
    "description": "asdsa",
    "url": "dsads",
    "no": 14,
    "created_at": null,
    "updated_at": null
}
class requestPaylaod{
    banner_id:number | null = null;
    file:File | null = null;
    title:String = "";
    description:String = "";
    url:String = "";
    thumb_url:String="";
    no:number | null = null;
}
@Component({
    components:{
        DeleteButton,
        EForm,
        Id,
        TextField,
        Number,
        ImageUpload
    }
})
export default class Slider extends Vue {
    baseAction:string = ActionsEnum.Banner;
    action:string = this.baseAction;
    dialog:boolean=false;
    items:Array<BannerEntity> | null = null;
    title:string="";
    uploadRequired = true;
    data:requestPaylaod = new requestPaylaod();
    edit(item:BannerEntity){
        this.data = new requestPaylaod();
        this.data.file = null;
        this.data.description = item.description;
        this.data.no = item.no;
        this.data.title = item.title;
        this.data.url = item.url;
        this.data.banner_id = item.banner_id;
        this.data.thumb_url = item.thumb_url;
        this.action =  this.baseAction + "/" + item.banner_id;
        this.title = "Düzenle";
        this.uploadRequired = false;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.data = new requestPaylaod();
        this.action = this.baseAction;
        this.dialog = true;
    }
    async getSliders(){
        this.dialog = false;
        let banner = await this.$http.get(this.baseAction);
        this.items = banner.data;
    }
    created(){
        this.getSliders();
    }
}
